import { TDocument } from '../documents/documents.interfaces';
import { TActions, TPaginatedResponse } from '../__shared/shared.interfaces';
import { TPrimaryDetails } from '../users/users.interfaces';

export enum PAYOUT_STATUS {
  PAID = 'PAID',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
}

export enum PAYMENT_METHOD {
  NEFT = 'NEFT',
  RTGS = 'RTGS',
  IMPS = 'IMPS',
  UPI = 'UPI',
  CHEQUE = 'CHEQUE',
  CASH = 'CASH',
}

export enum PAY_PERIOD {
  FULL_MONTH = 'FULL_MONTH',
  PARTIAL = 'PARTIAL',
  ADVANCE = 'ADVANCE',
}

export interface ISalaryBreakdown {
  // Earnings
  basic: number;
  hra?: number; // House Rent Allowance
  da?: number; // Dearness Allowance
  transportAllowance?: number;
  medicalAllowance?: number;
  specialAllowance?: number;
  otherAllowances?: number;
  grossSalary: number;

  // Deductions
  providentFund?: number; // PF
  employeeStateInsurance?: number; // ESI (if applicable)
  professionalTax?: number;
  incomeTax?: number; // TDS
  otherDeductions?: number;
  totalDeductions: number;

  // Net Salary
  netSalary: number;
}

export interface IBankDetails {
  accountNumber: string;
  ifscCode: string;
  bankName: string;
  branchName?: string;
}

export interface ITaxDetails {
  pan?: string; // Permanent Account Number
  uan?: string; // Universal Account Number (for PF)
  tdsAmount?: number;
  taxSlab?: string;
}

export interface IStaffPayout {
  payoutId: string;
  user: TPrimaryDetails;

  // Salary breakdown
  salaryBreakdown: ISalaryBreakdown;

  // Amount (kept for backward compatibility, should match netSalary)
  amount: number;

  // Period details
  month: string;
  year: number;
  financialYear: string; // e.g., "2024-25" (April to March)
  payPeriod: PAY_PERIOD;
  workingDays?: number;
  paidDays?: number;

  // Payment details
  status: PAYOUT_STATUS;
  paymentMethod?: PAYMENT_METHOD;
  paymentDate?: string;
  transactionReference?: string;
  bankDetails?: IBankDetails;

  // Tax and compliance
  taxDetails?: ITaxDetails;

  // Documents and metadata
  /** @deprecated Use document. TODO: Naman - Link payslip PDF to payout in backend */
  payslip?: TDocument;
  /** Payslip PDF linked to this payout. TODO: Naman - Link payslip PDF to payout in backend */
  document?: TDocument;
  actions: TActions;
  remarks?: string;

  // Additional tracking
  processedBy?: string;
  processedOn?: string;
  approvedBy?: string;
  approvedOn?: string;
}

export type IStaffPayoutResponse = TPaginatedResponse<IStaffPayout>;
